module.exports = __webpack_public_path__ + "bb2e-swap_title_pc.png";